import { FC, ReactNode } from 'react';

export type Step = {
  content: ReactNode;
  value: string | number;
};

type StepperProps = {
  steps: Step[];
  currentStep: number;
};

export const Stepper: FC<StepperProps> = ({ steps, currentStep }) => {
  const stepperContent = steps[currentStep]?.content;

  return <>{stepperContent}</>;
};
